export function isBasicPropType(propType) {
  if (!propType) {
    return false;
  }
  return typeof propType === 'string';
}